export default "__VITE_ASSET__c608d3ad__"